// src/components/ProgressBar.tsx
import React from "react";

interface ProgressBarProps {
  percentage: number;
  estimate?: Date;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ percentage, estimate }) => {
  return (
    <div style={{ margin: "1rem 0" }}>
      <div
        style={{
          width: "100%",
          backgroundColor: "#e0e0e0",
          borderRadius: "4px",
          height: "20px",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: `${percentage}%`,
            backgroundColor: "#007bff",
            height: "100%",
            transition: "width 0.5s ease-out",
          }}
        />
      </div>
      {estimate && (
        <p style={{ fontSize: "0.8rem", marginTop: "0.5rem" }}>
          Estimated completion: {estimate.toLocaleTimeString()}
        </p>
      )}
    </div>
  );
};

export default ProgressBar;

export enum Step {
    KeyReservation,
    Uploading,
    Minting,
    SettingPermissions,
    AwaitingFinality,
    Done,
    MetaMaskRejected = 100, // if needed
  }
  
  export function getProgressPercentage(step: Step): number {
    switch (step) {
      case Step.KeyReservation:
        return 10;
      case Step.Uploading:
        return 30;
      case Step.Minting:
        return 50;
      case Step.SettingPermissions:
        return 70;
      case Step.AwaitingFinality:
        return 90;
      case Step.Done:
        return 100;
      default:
        return 0;
    }
  }
  


